import { type CommandProperties } from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import { type ConfluenceCreateWhiteboardData } from './confluence-create-whiteboard-commands';

/**
 * Properties for the Confluence whiteboard initialization command.
 */
export interface ConfluenceWhiteboardInitCommandProperties extends CommandProperties {
	/**
	 * The contentId of the whiteboard being initialized.
	 */
	contentId: string;
	/**
	 * The action information to initialize the preview, equivalent format to Whiteboard create command
	 */
	data: ConfluenceCreateWhiteboardData;
}

/**
 * A command sent by a bridge API client to initialize a Confluence whiteboard preview with
 * the selected action's data once, after the content surface is ready.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId}
 * to initialize its state from the provided action payload.
 */
export const ConfluenceWhiteboardInitCommand = createCommand<
	ConfluenceWhiteboardInitCommandProperties,
	void
>('confluence-whiteboard-init-command');
